import { mapState } from 'vuex';

export default {
  name: 'ConnectivityStatus',
  data() {
    return {
      warningClose : false,
      isOnline     : window.navigator.onLine
    };
  },
  watch: {
    isOnline(newVal) {
      if (newVal) {
        this.warningClose = false;
      }
    }
  },
  mounted() {
    this.setOnlineStatusListeners();
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
  computed: {
    ...mapState({
      headerHeight: (state) => state._core.application.headerHeight
    }),
    connectivityStatusEnabled() {
      return process.env.CONNECTIVITY_STATUS_ENABLED === 'true';
    }
  },
  methods: {
    closeNotification() {
      this.warningClose = true;
    },
    setOnlineStatusListeners() {
      window.addEventListener('online', this.updateOnlineStatus);
      window.addEventListener('offline', this.updateOnlineStatus);
    },
    updateOnlineStatus() {
      this.isOnline = navigator.onLine;
    }
  }
};
